// removed by extract-text-webpack-plugin
module.exports = {"subSectionWrapper":"SummarySubSections__subSectionWrapper___1N1fY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SummarySubSections/SummarySubSections.less
// module id = 1232
// module chunks = 0